<template>
<v-container>
  <!-- Pie Chart View-->
    <v-row justify="center">
      <v-col cols="12" md="6">
        <pie-chart
          :title="title"
          :data="data"
          :clickable="false"
        />
      </v-col>
    </v-row>
</v-container>
</template>

<script>
import PieChart from '../components/PieChart.vue';

import LZString from 'lz-string';

export default {
  name: 'PiePreview',
  components: {
    PieChart
  },
  data: () => ({
    // Pie chart.
    title: 'Pie Preview',
    data: [
        ['Answer', 'Value'],
        ['Bad',     0],
        ['Ok',      0],
        ['Good',    0],
        ['Unused',  100]
    ],
  }),
  methods: {
    bin_to_utf: function(bin) {
      const bytes = new Uint8Array(bin.length);
      for (let i = 0; i < bytes.length; i++) {
        bytes[i] = bin.charCodeAt(i);
      }

      const charCodes = new Uint16Array(bytes.buffer);
      let result = '';
      for (let i = 0; i < charCodes.length; i++) {
        result += String.fromCharCode(charCodes[i]);
      }
      return result;
    },
  },
  mounted() {
    if (!this.$route.query.pie) {
      this.$router.push('/');
    }
    
    try {
        const query_lz = this.$route.query.pie;
        const query_json = LZString.decompressFromEncodedURIComponent(query_lz);
        const query = JSON.parse(query_json); 

        this.title = query.title;
        this.data = query.data;
    }
    catch (err) {
      this.$router.push('/');
    }
  }
}
</script>